/* ============================================================
   story-module-nbscrolly.js  —  Nadelöhr Sticky-Scene Modul
   Migration aus Code-Injection v19.7. Steuert .nb-scrolly-Panels
   (data-story-type="custom-nb-scrolly"). Self-Guard: tut nichts, wenn
   keine .nb-scrolly-Panels da sind → andere Stories unberührt.
   Blöcke: 1 Video · 2 BG-Stage · 3 Wort-Reveal · 4 Sticky-Text ·
           5 Audio-Bridge · 7 Atmo · 9 Home-Button.
   (Block 6 = window.storyMeta-Config bleibt als Mini-Injection im Post.)
   ============================================================ */
(function () {
  // Self-Guard: nur auf Nadelöhr-artigen Stories aktiv werden.
  if (!document.querySelector('.nb-scrolly')) return;

  /* ───────── Block-Segment 1 ───────── */
/* Block 1 — Video-Aktivierung: SINGLE-WINNER + gestufte Sequenz.
   Ziel (David, 2026-06-15): NIE zwei Videos gleichzeitig sichtbar.
   Ablauf bei Panelwechsel:  altes Video blendet aus  →  Hintergrundfarbe
   crossfadet (Block 2)  →  neues Video blendet ein.

   - Gewinner = sichtbares Panel mit höchstem DOM-Index. Deckt sich mit der
     Hintergrund-Wahl in Block 2, damit Video & Farbe synchron schalten.
   - Das neue Video wird erst nach NEW_VIDEO_DELAY_MS aktiv — also nachdem das
     alte (700ms CSS-Fade aus Block 2) verschwunden ist und die Farbfläche
     übergeblendet hat. So gibt es einen sauberen Nur-Farbe-Moment dazwischen.
   - COMMIT_DEBOUNCE_MS entprellt die Auswahl: kein Flackern beim Zögern an
     der Panelgrenze, keine Video-Einblendung für überscrollte Zwischenpanels.
   Die drei Zeitwerte sind frei justierbar (Timing „bremsen/beschleunigen"). */
(function() {
  var NEW_VIDEO_DELAY_MS = 800;   // Pause, bis das neue Video einblendet
  var COMMIT_DEBOUNCE_MS = 120;   // Entprellung der Gewinner-Auswahl

  function init() {
    var panels = Array.prototype.slice.call(document.querySelectorAll('.nb-scrolly'));
    if (!panels.length) return;

    var visible = new Set();
    var currentWinner = null;          // Panel, dessen Video gerade sichtbar ist
    var fadeInTimer = null, commitTimer = null;

    function videoOf(p) { return p ? p.querySelector('.nb-scrolly__video') : null; }

    // Aktives Panel = das vom Theme markierte .is-active (active-panel.js, ratio≥0.5):
    // EINE gemeinsame Quelle für Video/BG/Audio/Text. Verhindert „Video von Panel B,
    // Tafel von Panel A" an Zwischen-Scrollpositionen (vorher: höchster sichtbarer
    // DOM-Index → schon 1px Reinlugen des unteren Panels gewann). Fallback (höchster
    // sichtbarer Index) nur, solange das Theme noch kein is-active gesetzt hat.
    function pickWinner() {
      var act = document.querySelector('.nb-scrolly.story-panel.is-active');
      if (act) return act;
      if (visible.size === 0) return null;
      var chosen = null, max = -1;
      visible.forEach(function (p) {
        var i = panels.indexOf(p);
        if (i > max) { max = i; chosen = p; }
      });
      return chosen;
    }

    function showVideo(panel, wv) {
      wv.classList.add('is-active');
      var vid = wv.querySelector('video');
      if (vid) {
        // Von vorne starten (Bug, David 2026-06-16): die Cards haben autoplay+loop →
        // ohne Reset läuft das Video seit dem Seitenstart durch und man steigt mitten
        // im Loop ein. currentTime=0 = sauberer Start, sobald das Panel aktiv wird.
        try { vid.currentTime = 0; } catch (e) {}
        // Safari: ein anfangs verstecktes <video muted> startet nicht von selbst, wenn
        // es nur per CSS sichtbar wird — daher explizit abspielen (Chrome braucht's nicht).
        if (vid.play) { var pr = vid.play(); if (pr && pr.catch) pr.catch(function () {}); }
      }
      // Signal an Block 5 (O-Ton): das neue Video ist JETZT sichtbar — Ton soll
      // jetzt starten, nicht schon beim Panelwechsel. (Block 7/Atmo kann später
      // denselben Haken nutzen.)
      try {
        window.dispatchEvent(new CustomEvent('nb:video:shown', { detail: { panel: panel } }));
      } catch (e) { /* CustomEvent ist überall verfügbar; defensiv */ }
    }

    function commit() {
      var winner = pickWinner();
      if (winner === currentWinner) return;
      var prev = currentWinner;
      currentWinner = winner;

      // 1. altes Video ausblenden (CSS-Fade 700ms) und pausieren — so spielt
      //    immer nur EIN Video (Safari-freundlich, kein Mehrfach-Decoding).
      var pv = videoOf(prev);
      if (pv) {
        pv.classList.remove('is-active');
        var pvVid = pv.querySelector('video');
        if (pvVid && pvVid.pause) { try { pvVid.pause(); } catch (e) {} }
      }

      // 2. neues Video einblenden — erstes Panel sofort, sonst nach der Pause
      if (fadeInTimer) { clearTimeout(fadeInTimer); fadeInTimer = null; }
      var wv = videoOf(winner);
      if (!wv) return;
      if (!prev) {
        showVideo(winner, wv);                   // Initial: kein Vorgänger, kein Warten
      } else {
        fadeInTimer = setTimeout(function () {
          if (currentWinner === winner) showVideo(winner, wv);
        }, NEW_VIDEO_DELAY_MS);
      }
    }

    function schedule() {
      if (commitTimer) clearTimeout(commitTimer);
      commitTimer = setTimeout(commit, COMMIT_DEBOUNCE_MS);
    }

    // autoplay neutralisieren (Bug, David 2026-06-16): alle Videos einmal stoppen +
    // auf 0 setzen, damit nur das aktive Panel-Video läuft (Single-Decoding,
    // Safari-freundlich) und kein Hintergrund-Loop weiterdriftet. showVideo() startet
    // das aktive dann sauber bei 0.
    panels.forEach(function (p) {
      var c = videoOf(p), v = c && c.querySelector('video');
      if (v) { try { v.removeAttribute('autoplay'); v.pause(); v.currentTime = 0; } catch (e) {} }
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target);
      });
      schedule();
    }, { threshold: 0, rootMargin: '0px' });

    panels.forEach(function (p) { observer.observe(p); });

    // Auch auf den Wechsel des aktiven Panels (Theme) committen — nicht nur auf eigene
    // IO-Events. So schaltet das Video synchron zu is-active / Text / BG / Audio.
    window.addEventListener('story:panel:activated', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  /* ───────── Block-Segment 2 ───────── */
(function() {
  function hexToRgb(hex) {
    const m = hex.replace('#', '').match(/^([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i);
    if (!m) return null;
    return { r: parseInt(m[1], 16), g: parseInt(m[2], 16), b: parseInt(m[3], 16) };
  }

  function initBgStage() {
    if (document.querySelector('.nb-scrolly__bg-stage')) return;
    const stage = document.createElement('div');
    stage.className = 'nb-scrolly__bg-stage';
    document.body.insertBefore(stage, document.body.firstChild);

    const scnList = document.querySelectorAll('.nb-scrolly');
    const bgMap = new WeakMap();
    scnList.forEach(scn => {
      const bg = scn.style.background || scn.style.backgroundColor;
      if (bg) {
        bgMap.set(scn, bg);
        scn.style.background = '';
        scn.style.backgroundColor = '';
        scn.dataset.scnBg = bg;
      }
    });

    const visibleScenes = new Set();

    function updateBg() {
      // Aktives Panel = vom Theme markiertes .is-active (gleiche Quelle wie Video/
      // Audio/Text) → BG bleibt synchron. Fallback höchster sichtbarer DOM-Index
      // nur vor dem ersten is-active.
      let chosen = document.querySelector('.nb-scrolly.story-panel.is-active');
      if (!chosen) {
        if (visibleScenes.size === 0) return;
        let maxDomIndex = -1;
        visibleScenes.forEach(scn => {
          const idx = Array.from(scnList).indexOf(scn);
          if (idx > maxDomIndex) {
            maxDomIndex = idx;
            chosen = scn;
          }
        });
      }
      if (!chosen) return;

      const bg = bgMap.get(chosen);
      if (bg) {
        stage.style.backgroundColor = bg;
        const rgb = hexToRgb(bg);
        if (rgb) {
          document.documentElement.style.setProperty(
            '--nb-scrolly-text-bg',
            `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.4)`
          );
        }
      }
    }

    const bgObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          visibleScenes.add(entry.target);
        } else {
          visibleScenes.delete(entry.target);
        }
      });
      updateBg();
    }, { threshold: 0, rootMargin: '0px' });

    scnList.forEach(scn => bgObserver.observe(scn));
    updateBg();

    // Auch auf Theme-Panelwechsel die BG-Farbe nachziehen (synchron zu Video/Text).
    window.addEventListener('story:panel:activated', updateBg);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBgStage);
  } else {
    initBgStage();
  }
})();

  /* ───────── Block-Segment 3 ───────── */
(function() {
  // Tafel-Fade-Verzögerung (David, 2026-06-17): Tafel + Wort-Reveal + Highlight
  // erscheinen ETWAS SPÄTER, damit zuerst Szene/Video/Farbe stehen. EINE Stellschraube:
  // setzt die CSS-Var --nb-tafel-delay (Container-Fade in Block 4) UND den Basis-Offset
  // der Wort-/Highlight-Delays hier. Auf 0 setzen = Feature aus. Nur Desktop wirksam
  // (Block 4 staged nur Desktop; auf Mobile transitionieren die Wörter ohnehin nicht).
  const NB_TAFEL_DELAY_MS = 500;

  function initWordReveal() {
    document.documentElement.style.setProperty('--nb-tafel-delay', NB_TAFEL_DELAY_MS + 'ms');
    document.querySelectorAll('.nb-scrolly__quote-text').forEach(textEl => {
      if (textEl.dataset.revealInit) return;
      textEl.dataset.revealInit = 'true';

      const eyebrow = textEl.querySelector('.eyebrow');
      const eyebrowHtml = eyebrow ? eyebrow.outerHTML : '';

      let mainHtml = textEl.innerHTML;
      if (eyebrow) mainHtml = mainHtml.replace(eyebrow.outerHTML, '');

      mainHtml = mainHtml.replace(
        /<span class="hl">(.*?)<\/span>/g,
        '⟦HL⟧$1⟦/HL⟧'
      );

      // Zeilenumbrueche schuetzen: <br> als eigenes Token isolieren, damit es
      // NICHT in ein .word (inline-block) gewickelt wird (sonst kein Umbruch).
      mainHtml = mainHtml.replace(/<br\s*\/?>/gi, ' ⟦BR⟧ ');

      const tokens = mainHtml.trim().split(/(\s+)/);
      let wordIndex = 0;
      const wrapped = tokens.map(token => {
        if (/^\s+$/.test(token) || !token) return token;
        if (token === '⟦BR⟧') return '<br>';   // Zeilenumbruch, nicht als Wort wickeln
        const isHl = token.includes('⟦HL⟧');
        const cleanToken = token.replace(/⟦HL⟧/g, '').replace(/⟦\/HL⟧/g, '');
        const cls = isHl ? 'word is-hl' : 'word';
        const delay = NB_TAFEL_DELAY_MS + wordIndex * 80;
        wordIndex++;
        return `<span class="${cls}" style="transition-delay:${delay}ms">${cleanToken}</span>`;
      }).join('');

      textEl.innerHTML = eyebrowHtml + wrapped;

      const allWords = textEl.querySelectorAll('.word');
      const totalCount = allWords.length;
      allWords.forEach(w => {
        if (w.classList.contains('is-hl')) {
          w.style.transitionDelay = (NB_TAFEL_DELAY_MS + totalCount * 80 + 200) + 'ms';
        }
      });
    });

    // Mobil: Block 4 (Sticky-Staging, ≥1024px) läuft hier nicht → die gewrappten
    // Wörter bekämen nie .is-active und blieben unsichtbar. Wir setzen .is-active auf
    // die Quote, sobald ihre Tafel in den Viewport scrollt → die bestehende
    // .word-Transition fadet ein (inkl. Highlight), wie auf Desktop. Ersetzt Davids
    // frühere Post-Footer-Injection (die den Text hart ohne Fade zeigte).
    if (window.matchMedia('(max-width: 1023px)').matches && !window.__nbMobileRevealBound) {
      window.__nbMobileRevealBound = true;
      var mobIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var q = e.target.closest && e.target.closest('.nb-scrolly__quote');
          if (q) q.classList.add('is-active');
        });
      }, { threshold: 0.2 });
      document.querySelectorAll('.nb-scrolly__quote-text').forEach(function (t) { mobIO.observe(t); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWordReveal);
  } else {
    initWordReveal();
  }
})();

  /* ───────── Block-Segment 4 ───────── */
(function() {
  const FADE_OUT_MS = 400;

  function initStickyTextStrict() {
    if (window.matchMedia('(max-width: 1023px)').matches) return;

    document.querySelectorAll('.nb-scrolly').forEach(scn => {
      const quotes = Array.from(scn.querySelectorAll('.nb-scrolly__quote'));
      if (quotes.length === 0) return;

      let stageQuote = null;
      let desiredQuote = null;
      let transitionTimer = null;
      const visibleQuotes = new Set();

      function pickDesired() {
        // Nur stagen, wenn DIESES Panel das aktive ist (Theme-is-active, ratio≥0.5).
        // Verhindert, dass die Tafel eines nicht-aktiven Panels sichtbar bleibt
        // (Cross-Panel-Bleed: „Tafel von Panel A, Video von Panel B").
        if (!scn.classList.contains('is-active')) return null;
        if (visibleQuotes.size === 0) return null;
        const viewportMid = window.innerHeight / 2;
        let best = null;
        let bestDist = Infinity;
        visibleQuotes.forEach(q => {
          const rect = q.getBoundingClientRect();
          const mid = rect.top + rect.height / 2;
          const dist = Math.abs(mid - viewportMid);
          if (dist < bestDist) {
            bestDist = dist;
            best = q;
          }
        });
        return best;
      }

      // Tafel/Wörter erst zeigen, wenn das Video DIESES Panels sichtbar ist
      // (David, 2026-06-17: Tafel soll NACH dem Video kommen, nicht davor). Ist das
      // Video noch nicht da, wartet die Tafel auf 'nb:video:shown' (Block 1 feuert es,
      // sobald das Video erscheint — Listener unten). stageQuote merkt sich die Wahl,
      // sodass sie dann nachgezogen wird. Der CSS-Delay (--nb-tafel-delay) addiert
      // sich on top → Tafel erscheint ein Stück nach dem Video.
      function videoReady() {
        const v = scn.querySelector('.nb-scrolly__video');
        return !!(v && v.classList.contains('is-active'));
      }
      function reveal(q) {
        if (!q) return;
        if (videoReady()) {
          q.classList.add('is-stage');
          q.classList.add('is-active');
        }
      }

      function updateStage() {
        const wanted = pickDesired();
        if (wanted === desiredQuote) return;
        desiredQuote = wanted;

        if (!stageQuote && desiredQuote) {
          stageQuote = desiredQuote;
          reveal(stageQuote);
          return;
        }

        if (stageQuote && stageQuote !== desiredQuote) {
          const leaving = stageQuote;
          leaving.classList.remove('is-stage');
          leaving.classList.remove('is-active');
          stageQuote = null;

          if (transitionTimer) clearTimeout(transitionTimer);
          transitionTimer = setTimeout(() => {
            const next = pickDesired();
            if (next) {
              stageQuote = next;
              reveal(next);
            }
            desiredQuote = next;
          }, FADE_OUT_MS + 50);
        }
      }

      // Einzel-Quote-Panels (David, 2026-06-15): Tafel früh einblenden und vor
      // Panelende wieder ausfaden. Trigger-Höhe = --nb-single-quote-len (CSS
      // Block 1), kürzer als das Panel → erreicht im Viewport max. Ratio
      // 100/quote-len (bei 300vh = 0.33). threshold 0.2 fadet die Tafel ~ bei
      // quote-len·0.8 vom Panelanfang aus, davor langer Stand, danach Auslauf.
      // Multi-Quote-Panels bleiben bei 0.5 (gestapelte Quotes, unverändert).
      const stageThreshold = quotes.length === 1 ? 0.2 : 0.5;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            visibleQuotes.add(entry.target);
          } else {
            visibleQuotes.delete(entry.target);
          }
        });
        updateStage();
      }, { threshold: stageThreshold });

      quotes.forEach(q => observer.observe(q));

      // Bei Wechsel des aktiven Panels (Theme) neu bewerten: ein nicht mehr aktives
      // Panel blendet seine Tafel aus, das neu-aktive blendet seine ein. Sonst
      // bliebe eine gestagte Tafel hängen, bis ein eigenes IO-Event käme.
      window.addEventListener('story:panel:activated', updateStage);
      window.addEventListener('story:panel:deactivated', updateStage);

      // Video dieses Panels ist jetzt sichtbar (Block 1 feuert 'nb:video:shown') →
      // eine wartende Tafel jetzt nachträglich einblenden. Idempotent.
      window.addEventListener('nb:video:shown', e => {
        if (e.detail && e.detail.panel === scn && stageQuote) {
          stageQuote.classList.add('is-stage');
          stageQuote.classList.add('is-active');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyTextStrict);
  } else {
    initStickyTextStrict();
  }
})();

  /* ───────── Block-Segment 5 ───────── */
(function() {
  let unlockRetryDone = false;
  function triggerUnlock() {
    if (window.StoryMediaManager && typeof window.StoryMediaManager.enableAutoplay === 'function') {
      try { window.StoryMediaManager.enableAutoplay(); } catch (e) { /* still */ }
    }
    if (!unlockRetryDone) {
      unlockRetryDone = true;
      setTimeout(retryStuckAudio, 50);
    }
  }
  function retryStuckAudio() {
    const pa = window.StoryModulePanelAudio;
    if (!pa) return;
    const stuck = pa.currentAudio && pa.currentAudio.paused && pa.isPlaying;
    if (!stuck) return;
    try {
      const p = pa.currentAudio.play();
      if (p && p.catch) p.catch(() => { /* still */ });
    } catch (e) { /* still */ }
  }
  ['click', 'touchstart', 'keydown'].forEach(ev => {
    document.addEventListener(ev, triggerUnlock, { passive: true });
  });

  function initAudioBridge() {
    if (!window.StoryMediaManager) {
      console.warn('[NADELOEHR Audio-Bridge] StoryMediaManager nicht gefunden — Audio inaktiv.');
      return;
    }

    const activeScn = { current: null };
    let audioStartedFor = null;   // Panel, dessen O-Ton bereits gestartet wurde

    // Doppel-Start verhindern (Bug, David 2026-06-16): das Theme ruft über den
    // MediaManager bei JEDER Panel-Aktivierung (story:panel:activated, ratio≥0.5)
    // automatisch StoryModulePanelAudio.init(panel) — ZUSÄTZLICH zu unserem an
    // 'nb:video:shown' gekoppelten Aufruf. Beide zusammen = O-Ton zweimal.
    // Lösung: Block 5 wird ALLEINIGER Auslöser. Wir kapseln init() so, dass nur
    // unser eigener (per Flag freigegebener) Aufruf durchläuft; die Theme-Auto-
    // Inits werden unterdrückt. Timing „Ton startet mit dem Video" bleibt erhalten.
    let allowPanelAudioInit = false;
    if (window.StoryModulePanelAudio &&
        typeof window.StoryModulePanelAudio.init === 'function' &&
        !window.StoryModulePanelAudio.__nbInitWrapped) {
      const realInit = window.StoryModulePanelAudio.init.bind(window.StoryModulePanelAudio);
      window.StoryModulePanelAudio.init = function (panel) {
        if (!allowPanelAudioInit) return;   // Theme-Auto-Init unterdrücken
        return realInit(panel);
      };
      window.StoryModulePanelAudio.__nbInitWrapped = true;
    }

    const pulse = document.createElement('div');
    pulse.className = 'nb-scrolly__pulse';
    pulse.style.color = '#1a1a1a';
    document.body.appendChild(pulse);

    function hasAudio(scn) {
      return !!scn.querySelector('.story-panel-audio');
    }

    function audioElsOf(scn) {
      return Array.from(scn.querySelectorAll('.story-panel-audio'));
    }

    function isAudioPlaying(scn) {
      return audioElsOf(scn).some(a => !a.paused && !a.ended);
    }

    function allAudiosFinished(scn) {
      const els = audioElsOf(scn);
      if (els.length === 0) return false;
      return els.every(a => a.dataset.scnFinished === 'true');
    }

    function setupSceneAudioListeners(scn) {
      audioElsOf(scn).forEach(a => {
        if (a.dataset.scnListenersBound === 'true') return;
        a.dataset.scnListenersBound = 'true';

        a.addEventListener('ended', () => {
          a.dataset.scnFinished = 'true';
          if (allAudiosFinished(scn) && activeScn.current === scn) {
            scn.classList.remove('audio-locked');
            showPulse();
          }
        });

        a.addEventListener('play', () => {
          a.dataset.scnFinished = 'false';
          if (activeScn.current === scn) {
            scn.classList.add('audio-locked');
            hidePulse();
          }
        });
      });
    }

    function showPulse() { pulse.classList.add('is-visible'); }
    function hidePulse() { pulse.classList.remove('is-visible'); }

    // Nachbar-O-Ton VORLADEN (Bug, David 2026-06-16): das Theme lädt die Audio-
    // Datei erst beim Aktivieren des Panels (panel-audio.js: lazy src) → erste
    // Wiedergabe je Panel holt die Datei live = hörbare Lücke (v.a. Panel 3–6).
    // Wir wärmen den HTTP-Cache des direkten Nachbarn über ein LOSGELÖSTES
    // Audio-Objekt vor — ohne das echte Element oder die Theme-Logik anzufassen.
    // Wenn das Panel später aktiv wird, setzt das Theme denselben src → Cache-Hit.
    const warmedAudio = {};
    function warmNeighborAudio(scn) {
      const all = Array.from(document.querySelectorAll('.nb-scrolly'));
      const next = all[all.indexOf(scn) + 1];
      if (!next) return;
      const a = next.querySelector('.story-panel-audio');
      const url = a && a.getAttribute('data-audio');
      if (!url || warmedAudio[url]) return;
      try {
        const w = new Audio();
        w.preload = 'auto';
        w.src = url;
        w.load();
        warmedAudio[url] = w;   // Referenz halten (gegen GC), reines Cache-Warming
      } catch (e) { /* still */ }
    }

    function activatePanel(scn) {
      if (activeScn.current === scn) {
        if (allAudiosFinished(scn) && !isAudioPlaying(scn)) showPulse();
        return;
      }

      if (activeScn.current) {
        const prev = activeScn.current;
        prev.classList.remove('audio-locked');
        try {
          if (window.StoryModulePanelAudio && typeof window.StoryModulePanelAudio.pause === 'function') {
            window.StoryModulePanelAudio.pause();
          }
        } catch (e) { /* still */ }
      }
      hidePulse();

      activeScn.current = scn;
      audioStartedFor = null;
      warmNeighborAudio(scn);   // direkten Nachbar-O-Ton vorladen (Cache-Warming)

      if (!hasAudio(scn)) return;

      // O-Ton NICHT sofort starten, sondern erst wenn Block 1 das neue Video
      // einblendet (Event 'nb:video:shown'). Ist das Video bereits sichtbar
      // (erstes Panel, synchron gesetzt), starten wir direkt.
      const v = scn.querySelector('.nb-scrolly__video');
      if (v && v.classList.contains('is-active')) startSceneAudio(scn);
    }

    function startSceneAudio(scn) {
      if (!hasAudio(scn) || audioStartedFor === scn) return;
      audioStartedFor = scn;
      setupSceneAudioListeners(scn);
      try {
        if (window.StoryModulePanelAudio && typeof window.StoryModulePanelAudio.init === 'function') {
          allowPanelAudioInit = true;            // nur unser Aufruf darf durch
          window.StoryModulePanelAudio.init(scn);
        }
      } catch (e) {
        console.warn('[NADELOEHR Audio-Bridge] Panel-Audio init() fehlgeschlagen:', e);
      } finally {
        allowPanelAudioInit = false;             // Theme-Auto-Init wieder sperren
      }
    }

    const visibleScenes = new Set();

    function pickActive() {
      // Aktives Panel = vom Theme markiertes .is-active (gleiche Quelle wie Video/BG/
      // Text) → O-Ton bleibt synchron, kein „Audio von Panel B". Fallback höchster
      // sichtbarer DOM-Index nur vor dem ersten is-active.
      const act = document.querySelector('.nb-scrolly.story-panel.is-active');
      if (act) return act;
      if (visibleScenes.size === 0) return null;
      let chosen = null;
      let maxDomIndex = -1;
      const all = Array.from(document.querySelectorAll('.nb-scrolly'));
      visibleScenes.forEach(scn => {
        const idx = all.indexOf(scn);
        if (idx > maxDomIndex) {
          maxDomIndex = idx;
          chosen = scn;
        }
      });
      return chosen;
    }

    // Audio-Aktivierung ENTPRELLEN (Bug, David 2026-06-16): mandatory-Snap kreuzt
    // an Panelgrenzen die IO-Schwelle mehrfach (Bounce). Ohne Debounce pausierte
    // Block 5 bei jedem Bounce den O-Ton und nahm ihn aus der gesicherten Position
    // gleich wieder auf → hörbares Stottern („spielt an, stockt, springt neu").
    // Block 1 (Video) entprellt seine Auswahl bereits mit 120ms; hier ziehen wir
    // mit (etwas länger, Audio ist empfindlicher) und committen den Panelwechsel
    // erst, wenn sich die Grenze beruhigt hat. Auswahl (pickActive) folgt dem
    // Theme-is-active wie Block 1/2/4 → O-Ton & Video bleiben im Gleichtakt; der
    // eigentliche Start ist weiterhin an 'nb:video:shown' gekoppelt.
    const AUDIO_COMMIT_DEBOUNCE_MS = 150;
    let audioCommitTimer = null;

    function commitActivePanel() {
      audioCommitTimer = null;
      const next = pickActive();
      if (next) {
        activatePanel(next);
      } else {
        if (activeScn.current) {
          const prev = activeScn.current;
          prev.classList.remove('audio-locked');
          try {
            if (window.StoryModulePanelAudio && typeof window.StoryModulePanelAudio.pause === 'function') {
              window.StoryModulePanelAudio.pause();
            }
          } catch (e) { /* still */ }
          activeScn.current = null;
        }
        hidePulse();
      }
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          visibleScenes.add(entry.target);
        } else {
          visibleScenes.delete(entry.target);
        }
      });
      if (audioCommitTimer) clearTimeout(audioCommitTimer);
      audioCommitTimer = setTimeout(commitActivePanel, AUDIO_COMMIT_DEBOUNCE_MS);
    }, { threshold: 0, rootMargin: '0px' });

    document.querySelectorAll('.nb-scrolly').forEach(scn => observer.observe(scn));

    // Auch auf Theme-Panelwechsel committen (debounced), nicht nur auf eigene IO —
    // hält die O-Ton-Auswahl synchron zu is-active / Video / BG / Text.
    window.addEventListener('story:panel:activated', function () {
      if (audioCommitTimer) clearTimeout(audioCommitTimer);
      audioCommitTimer = setTimeout(commitActivePanel, AUDIO_COMMIT_DEBOUNCE_MS);
    });

    // O-Ton-Start fest an die Video-Einblendung (Block 1) koppeln: Block 1 feuert
    // 'nb:video:shown', sobald das neue Video erscheint. Nur starten, wenn das
    // Panel dann noch das aktive ist (gegen Race bei schnellem Scrollen).
    window.addEventListener('nb:video:shown', function (e) {
      const panel = e.detail && e.detail.panel;
      if (panel && panel === activeScn.current) startSceneAudio(panel);
    });
  }

  function tryInitBridge(attempts) {
    if (window.StoryMediaManager) {
      initAudioBridge();
      return;
    }
    if (attempts > 20) {
      console.warn('[NADELOEHR Audio-Bridge] StoryMediaManager nach 20 Versuchen nicht gefunden.');
      return;
    }
    setTimeout(function() { tryInitBridge(attempts + 1); }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { tryInitBridge(0); });
  } else {
    tryInitBridge(0);
  }
})();

  /* ───────── Block-Segment 6 ───────── */
(function () {
  'use strict';
  var FADE_MS = 900;          // Panel→Panel-Crossfade
  var LOOP_XFADE_MS = 650;    // nahtloser Eigen-Loop (Naht-Crossfade) — Bestwert aus dem Loop-Test
  var DUCK_FADE_MS = 300, UNDUCK_FADE_MS = 500;
  var SWITCH_DEBOUNCE_MS = 200, STEP_MS = 50, SEAM_TICK_MS = 100;
  var BASE_VOL = 0.40, DUCK_VOL = 0.12;

  var decks = [makeDeck(), makeDeck()];
  var active = -1, currentSrc = null, pendingSrc = null;
  var started = false, muted = false, ducked = false;
  var fadeT = [null, null], switchT = null, seamT = null, handing = false, toggleBtn = null;
  var panels = [], visible = new Set();

  // loop=false: das nahtlose Looping macht der Seam-Crossfade (seamTick) unten.
  // Natives MP3-loop hat an der Naht eine hörbare Lücke (Encoder-Padding).
  function makeDeck() { var a = new Audio(); a.loop = false; a.preload = 'auto'; a.volume = 0; return a; }

  function clearFade(i) { if (fadeT[i]) { clearInterval(fadeT[i]); fadeT[i] = null; } }
  function fade(i, target, dur, pauseAtEnd) {
    var d = decks[i]; if (!d) return; clearFade(i);
    var steps = Math.max(1, Math.round(dur / STEP_MS));
    var start = d.volume, delta = (target - start) / steps, step = 0;
    fadeT[i] = setInterval(function () {
      step++;
      if (step >= steps) {
        d.volume = Math.max(0, Math.min(1, target)); clearFade(i);
        if (pauseAtEnd && target === 0) { try { d.pause(); } catch (e) {} }
      } else { d.volume = Math.max(0, Math.min(1, start + delta * step)); }
    }, STEP_MS);
  }

  function volTarget() { return muted ? 0 : (ducked ? DUCK_VOL : BASE_VOL); }

  // Übergabe auf das jeweils ANDERE Deck — für Panelwechsel (neue URL) UND
  // für den nahtlosen Eigen-Loop (gleiche URL kurz vor Ende).
  function handoff(url, fadeMs) {
    var inc = (active === -1) ? 0 : (1 - active), out = active;
    var d = decks[inc]; clearFade(inc);
    if (d.getAttribute('src') !== url) d.src = url;
    try { d.currentTime = 0; } catch (e) {}
    d.volume = 0;
    var p = d.play(); if (p && p.catch) p.catch(function () {});
    fade(inc, volTarget(), fadeMs, false);
    if (out !== -1 && out !== inc) fade(out, 0, fadeMs, true);
    active = inc; currentSrc = url; showToggle();
  }

  function crossfadeTo(url) {
    if (url === currentSrc) return;
    if (url === null) { if (active !== -1) fade(active, 0, FADE_MS, true); active = -1; currentSrc = null; return; }
    handing = true;                                   // Seam-Trigger während des Panel-Crossfades aussetzen
    handoff(url, FADE_MS);
    setTimeout(function () { handing = false; }, FADE_MS);
  }

  // Nahtloser Eigen-Loop: kurz vor Ende des aktiven Decks auf das andere Deck
  // mit GLEICHER Quelle überblenden (LOOP_XFADE_MS) — statt nativem loop mit Lücke.
  function seamTick() {
    if (handing || active === -1 || currentSrc === null) return;
    var d = decks[active];
    if (!d || !isFinite(d.duration) || d.duration === 0) return;
    if (d.duration - d.currentTime <= LOOP_XFADE_MS / 1000) {
      handing = true;
      handoff(currentSrc, LOOP_XFADE_MS);
      setTimeout(function () { handing = false; }, LOOP_XFADE_MS);
    }
  }

  function scheduleSwitch() {
    if (pendingSrc === currentSrc) { if (switchT) { clearTimeout(switchT); switchT = null; } return; }
    if (switchT) clearTimeout(switchT);
    switchT = setTimeout(function () { switchT = null; if (pendingSrc !== currentSrc) crossfadeTo(pendingSrc); }, SWITCH_DEBOUNCE_MS);
  }
  function requestSrc(url) { if (url === pendingSrc) return; pendingSrc = url; if (started) scheduleSwitch(); }

  function pickActive() {
    // Aktives Panel = Theme-.is-active (gleiche Quelle wie Video/BG/Audio/Text seit
    // v19.3). Verhindert „Atmo im falschen Panel" + überlappende Crossfades beim
    // Zurückscrollen (vorher: höchster sichtbarer DOM-Index → kippte aufs verlassene
    // Panel). Fallback höchster sichtbarer Index nur vor dem ersten is-active.
    var act = document.querySelector('.nb-scrolly.story-panel.is-active');
    if (act) return act;
    if (visible.size === 0) return null;
    var chosen = null, max = -1;
    visible.forEach(function (p) { var i = panels.indexOf(p); if (i > max) { max = i; chosen = p; } });
    return chosen;
  }
  function onChange() {
    var p = pickActive();
    requestSrc(p ? (p.getAttribute('data-ambient') || null) : pendingSrc);
  }

  function startNow() { if (started) return; started = true; if (pendingSrc && pendingSrc !== currentSrc) crossfadeTo(pendingSrc); }

  function speaker(on) {
    return on
      ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/></svg>'
      : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
  }
  function createToggle() {
    if (document.querySelector('.nb-atmo-toggle, .ambient-toggle')) return;
    var b = document.createElement('button');
    b.className = 'nb-atmo-toggle'; b.innerHTML = speaker(true); b.style.display = 'none';
    b.setAttribute('aria-label', 'Ton ein/aus');
    b.setAttribute('title', 'Ton ein/aus');
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); toggleMute(); });
    document.body.appendChild(b); toggleBtn = b;
  }
  function showToggle() { if (toggleBtn) toggleBtn.style.display = ''; }
  function toggleMute() {
    muted = !muted;
    // Atmo (Block 6/7)
    if (active !== -1) fade(active, muted ? 0 : (ducked ? DUCK_VOL : BASE_VOL), 200, false);
    // Haupt-O-Ton (Block 5 / PanelAudio) mitschalten → der Knopf oben links ist
    // ein echter „Ton ein/aus", nicht nur Atmo (David, 2026-06-28). Unmute läuft im
    // Klick = User-Geste → iOS spielt sofort hörbar weiter.
    if (window.StoryModulePanelAudio && typeof window.StoryModulePanelAudio.setMuted === 'function') {
      try { window.StoryModulePanelAudio.setMuted(muted); } catch (e) { /* still */ }
    }
    if (toggleBtn) { toggleBtn.innerHTML = speaker(!muted); toggleBtn.classList.toggle('is-muted', muted); }
  }

  function init() {
    panels = Array.prototype.slice.call(document.querySelectorAll('.nb-scrolly'));
    if (panels.length === 0) return;
    if (!document.querySelector('.nb-scrolly[data-ambient]')) return; // keine Atmo-Tour
    createToggle();

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
      onChange();
    }, { threshold: 0, rootMargin: '0px' });
    panels.forEach(function (p) { obs.observe(p); });

    // Auch auf Theme-Panelwechsel die Atmo-Quelle nachziehen (synchron zu Video/BG/
    // Audio/Text) — sonst kippte die Auswahl beim Zurückscrollen aufs verlassene Panel.
    window.addEventListener('story:panel:activated', onChange);

    seamT = setInterval(seamTick, SEAM_TICK_MS);   // nahtloser Eigen-Loop (Naht-Crossfade)

    window.addEventListener('story:media:ducking',   function () { ducked = true;  if (active !== -1 && !muted) fade(active, DUCK_VOL, DUCK_FADE_MS, false); });
    window.addEventListener('story:media:unducking', function () { ducked = false; if (active !== -1 && !muted) fade(active, BASE_VOL, UNDUCK_FADE_MS, false); });

    window.addEventListener('story:started', startNow);
    ['click', 'touchstart', 'keydown'].forEach(function (ev) {
      document.addEventListener(ev, function once() { document.removeEventListener(ev, once); startNow(); }, { passive: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  /* ───────── Block-Segment 7 ───────── */
(function nbHomeButton() {
  function inject() {
    var panels = document.querySelectorAll('.nb-scrolly');
    if (!panels.length) return;
    // Ziel + Beschriftung sprachabhängig: pro Post über window.storyMeta setzen
    // (DE-Post → Default unten; EN-Post → en-home + EN-Label). Fallback = DE.
    var meta  = window.storyMeta || {};
    var HOME  = meta.homeUrl   || 'https://www.grenzwandler.app';
    var LABEL = meta.homeLabel || 'Zurück zur Startseite';
    var last = panels[panels.length - 1];
    var texts = last.querySelectorAll('.nb-scrolly__quote-text');
    if (!texts.length) return;
    var target = texts[texts.length - 1];      // letzte Tafel im letzten Panel

    target.dataset.revealInit = 'true';          // Wort-Reveal überspringt diese Tafel
    var a = document.createElement('a');
    a.className = 'nb-home-btn';
    a.href = HOME;
    a.textContent = LABEL;
    target.innerHTML = '';
    target.appendChild(a);
  }

  function run() {
    // nach dem Wort-Reveal (der auf DOMContentLoaded/synchron läuft) ausführen
    requestAnimationFrame(inject);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

})();
